<p-toast></p-toast>

<div class="card">
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple icon="pi pi-plus" class="p-mr-4 z-5" (click)="openNew()"></button>
            <!--button pButton pRipple [label]="Delete" icon="pi pi-trash" class="p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedProducts || !selectedProducts.length"></button-->
        </ng-template>

        <!--<ng-template pTemplate="right">
            <p-fileUpload mode="basic" accept="image/*" [maxFileSize]="1000000" label="Import" chooseLabel="Import" class="p-mr-2 p-d-inline-block"></p-fileUpload>
            <button pButton pRipple label="Export" icon="pi pi-upload" class="p-button-help"></button>
        </ng-template>-->
    </p-toolbar>

    <p-table #dt [value]="listCountries" [rows]="10" [paginator]="true"
        [globalFilterFields]="['descrip','countryId','area','offLang']" [rowHover]="true" dataKey="countryId"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true">
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-center p-jc-between">
                <h5 class="p-m-0">Ciudades / Estados</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="Search..." />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="countryId">id <p-sortIcon field="countryId"></p-sortIcon></th>
                <th pSortableColumn="descrip">Nombre <p-sortIcon field="descrip"></p-sortIcon></th>
                <th pSortableColumn="area">Código de área <p-sortIcon field="area"></p-sortIcon></th>
                <th pSortableColumn="offLang">Idioma <p-sortIcon field="currCode"></p-sortIcon></th>
                <th pSortableColumn="currCode">Moneda <p-sortIcon field="offLang"></p-sortIcon></th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-country>
            <tr>
                <td>{{country.countryId}}</td>
                <td>{{country.descrip}}</td>
                <td>{{country.area}}</td>
                <td>{{country.offLang}}</td>
                <td>{{country.currCode}}</td>
                <td>
                    <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
                        (click)="editCountry(country)"></button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="summary">
            <div class="p-d-flex p-ai-center p-jc-between">
                In total there are {{listCountries ? listCountries.length : 0 }} zones.
            </div>
        </ng-template>
    </p-table>
</div>

<p-dialog [(visible)]="countryDialog" [style]="{width: '450px'}" header="País" [modal]="true" styleClass="p-fluid">
    <ng-template pTemplate="content">
        <div class="p-field">
            <label for="countryId">País: * </label>
            <input type="text" pInputText id="countryId" [(ngModel)]="country.countryId" required autofocus />
            <small class="p-error" *ngIf="submitted && !country.countryId">País requerido.</small>
        </div>
        <div class="p-field">
            <label for="descrip">Nombre: *</label>
            <input type="text" pInputText id="descrip" [(ngModel)]="country.descrip" required autofocus />
            <small class="p-error" *ngIf="submitted && !country.descrip">Nombre es requerido.</small>
        </div>
        <div class="p-field">
            <label for="area">Código de área: *</label>
            <input type="text" pInputText id="area" [(ngModel)]="country.area" required autofocus />
            <small class="p-error" *ngIf="submitted && !country.area">Código de es requerido.</small>
        </div>

        <!--

        <div class="p-field">
            <label for="inventoryStatus">Inventory Status</label>
            <p-dropdown [(ngModel)]="product.inventoryStatus" inputId="inventoryStatus" [options]="statuses" placeholder="Select">
                <ng-template let-option pTemplate="item">
                    <span [class]="'product-badge status-' + option.value">{{option.label}}</span>
                </ng-template>
            </p-dropdown>
        </div>

        <div class="p-field">
            <label class="p-mb-3">Category</label>
            <div class="p-formgrid p-grid">
                <div class="p-field-radiobutton p-col-6">
                    <p-radioButton id="category1" name="category" value="Accessories" [(ngModel)]="product.category"></p-radioButton>
                    <label for="category1">Accessories</label>
                </div>
                <div class="p-field-radiobutton p-col-6">
                    <p-radioButton id="category2" name="category" value="Clothing" [(ngModel)]="product.category"></p-radioButton>
                    <label for="category2">Clothing</label>
                </div>
                <div class="p-field-radiobutton p-col-6">
                    <p-radioButton id="category3" name="category" value="Electronics" [(ngModel)]="product.category"></p-radioButton>
                    <label for="category3">Electronics</label>
                </div>
                <div class="p-field-radiobutton p-col-6">
                    <p-radioButton id="category4" name="category" value="Fitness" [(ngModel)]="product.category"></p-radioButton>
                    <label for="category4">Fitness</label>
                </div>
            </div>
        </div>

        <div class="p-formgrid p-grid">
            <div class="p-field p-col">
                <label for="price">Price</label>
                <p-inputNumber id="price" [(ngModel)]="product.price" mode="currency" currency="USD" locale="en-US"></p-inputNumber>
            </div>
            <div class="p-field p-col">
                <label for="quantity">Quantity</label>
                <p-inputNumber id="quantity" [(ngModel)]="product.quantity"></p-inputNumber>
            </div>
        </div>
        -->
    </ng-template>

    <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
            (click)="hideDialog()"></button>
        <button pButton pRipple label="Guardar" icon="pi pi-check" class="p-button-text"
            (click)="saveProduct()"></button>
    </ng-template>
</p-dialog>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>